import styled from 'styled-components';

interface Props {
  hide: boolean;
}

const SearchMask = styled.div<Props>`
  opacity: ${(props) => (props.hide ? 0.4 : 1)};
`;

export default SearchMask;
